import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PriceTableDto } from '@tiendanube/common';
import priceTablesService from 'domains/Customers/PriceTables/priceTablesService/priceTablesService';
import {
  statusType,
  PriceTablesInterface,
} from 'domains/Customers/PriceTables/priceTablesSlice/types';

const initialState: PriceTablesInterface = {
  priceTables: {
    data: [],
    status: statusType.idle,
  },
};

export const getPriceTables = createAsyncThunk<PriceTableDto[], void>(
  'priceTables/getPriceTables',
  async () => await priceTablesService.getPriceTables(),
);

const priceTables = createSlice({
  name: 'priceTables',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPriceTables.pending, (state) => {
        state.priceTables.status = statusType.loading;
      })
      .addCase(getPriceTables.fulfilled, (state, action) => {
        state.priceTables.data = action.payload;
        state.priceTables.status = statusType.success;
      })
      .addCase(getPriceTables.rejected, (state) => {
        state.priceTables.status = statusType.error;
      });
  },
});

export const { reducer } = priceTables;
